export default __webpack_public_path__ + "static/media/half-circle.3f81e8f0.svg";